import { i18n } from '~/utils';

/**
 * Returns the customer contract number, or the localized "no contract number"
 * placeholder when the contract has none. Deliberately no fallback to the
 * seller number or the contract ID: those would pass for a customer number.
 */
export function getContractNumberLabel(
  buyerAssignedId: string | null | undefined,
) {
  return (
    buyerAssignedId?.trim() ||
    i18n.t(($) => $.noContractNumber, { ns: 'contract' })
  );
}
